import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  margin-bottom: ${({ theme }) => theme.spacing.md};
  align-items: flex-start;
  gap: 6px;

  &.user {
    flex-direction: row-reverse;
  }
`;

export const Avatar = styled.div`
  flex-shrink: 0;
  margin-top: 2px;
  width: 24px;
  height: 24px;
  background-color: ${({ theme }) => theme.colors.background.tertiary};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.text.secondary};

  .user & {
    background-color: #007AFF;
    color: ${({ theme }) => theme.colors.background.primary};
  }
`;

export const Content = styled.div`
  flex: 1;
  position: relative;

  &.user {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  &.assistant {
    display: block;
  }
`;

export const Text = styled.div`
  background-color: ${({ theme }) => theme.colors.background.primary};
  padding: ${({ theme }) => theme.spacing.xs} ${({ theme }) => theme.spacing.sm};
  border-radius: ${({ theme }) => theme.borderRadius.medium};
  font-size: ${({ theme }) => theme.fontSize.md};
  line-height: 1.4;
  color: ${({ theme }) => theme.colors.text.primary};
  word-wrap: break-word;
  box-shadow: ${({ theme }) => theme.shadow.sm};
  display: inline-block;
  max-width: 100%;
  width: fit-content;
  box-sizing: border-box;
  overflow-wrap: break-word;
  word-break: break-word;

  /* Target ReactMarkdown elements */
  p, ol, ul, li {
    margin: 0;
    padding: 0;
    width: 100%;
    word-wrap: break-word;
    overflow-wrap: break-word;
    word-break: break-word;
  }

  ol, ul {
    padding-left: 1.2em;
  }

  /* Style images in markdown */
  img {
    height: 200px;
    object-fit: cover;
    border-radius: ${({ theme }) => theme.borderRadius.small};
    margin: ${({ theme }) => theme.spacing.xs} 0;
    display: block;
  }

  h3 {
    margin: ${({ theme }) => theme.spacing.sm} 0 ${({ theme }) => theme.spacing.xs} 0;
    font-size: ${({ theme }) => theme.fontSize.md};
    font-weight: 600;
  }

  .user & {
    background-color: #007AFF;
    color: ${({ theme }) => theme.colors.background.primary};
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }

  .assistant & {
    background-color: ${({ theme }) => theme.colors.background.primary};
    border: 1px solid ${({ theme }) => theme.colors.border.primary};
    border-radius: ${({ theme }) => theme.borderRadius.medium};
  }
`;

export const Actions = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.sm};
  margin-top: ${({ theme }) => theme.spacing.xs};
  opacity: 0;
  transition: ${({ theme }) => theme.transitions.default};

  .assistant:hover & {
    opacity: 1;
  }
`;

export const ActionButton = styled.button`
  background: none !important;
  border: none !important;
  padding: 4px;
  border-radius: ${({ theme }) => theme.borderRadius.small};
  cursor: pointer;
  color: ${({ theme }) => theme.colors.text.secondary};
  transition: ${({ theme }) => theme.transitions.default};
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 28px;
  height: 28px;
  outline: none !important;
  box-shadow: none !important;

  &:hover {
    background-color: ${({ theme }) => theme.colors.background.tertiary};
    color: ${({ theme }) => theme.colors.text.primary};
    border: none !important;
    box-shadow: none !important;
  }

  &:focus {
    outline: none !important;
    box-shadow: none !important;
    border: none !important;
  }

  &:active {
    outline: none !important;
    box-shadow: none !important;
    border: none !important;
  }

  &:visited {
    border: none !important;
    box-shadow: none !important;
  }
`;
